import React from 'react';

const GoBookNowLogo = ({ height = "100", className = "" }) => {
  // Calculate the font size based on the provided height
  const fontSize = Math.max(parseInt(height) / 3, 16);
  
  return (
    <div className={`inline-flex items-center ${className}`}>
      <div 
        className="font-bold text-center" 
        style={{ 
          fontSize: `${fontSize}px`, 
          lineHeight: 1.2,
          height: `${height}px`,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <span className="text-blue-600">Go</span>
        <span className="text-blue-800">BookNow</span>
      </div>
    </div>
  );
};

export default GoBookNowLogo;